import React from 'react';
import { OptionContentType, OptionWithValueType } from '../../../../interfaces/dynamicForms/FormBuilder';
import { Button } from 'react-bootstrap';
import "./FormBuilder.css";

interface OptionsEditorProps {
    options: OptionContentType[];
    updateOptions: (newOptions: OptionContentType[]) => void;
    disabled?: boolean;
}

const OptionsEditor: React.FC<OptionsEditorProps> = ({ options = [], updateOptions, disabled = false }) => {

    const handleOptionChange = (index: number, field: 'label' | 'value', value: string) => {
        const newOptions = [...options];
        const currentOption = newOptions[index];

        // Ensure we are working with the object format { value, label }
        let objectOption: OptionWithValueType;
        if (typeof currentOption === 'string') {
            // Convert simple string option to object format upon editing
            objectOption = { value: currentOption, label: currentOption };
        } else {
            objectOption = { ...currentOption }; // Clone existing object option
        }

        objectOption[field] = value;
        newOptions[index] = objectOption;
        updateOptions(newOptions);
    };
    const addOption = () => { updateOptions([...options, { value: '', label: '' }]); };
    const removeOption = (index: number) => { updateOptions(options.filter((_, i) => i !== index)); };
    const getOptionDisplay = (option: OptionContentType): { value: string, label: string } => {
        if (typeof option === 'string') return { value: option, label: option };
        return { value: option.value ?? '', label: option.label ?? '' };
    };

    return (
        <>
            <div className={` common_card ${disabled ? '' : ''}`} style={{backgroundColor : 'var(--main-content-bg)'}}>
                <div className="top border_tittle">
                    <div className="top_bar_tittle flex-column align-items-start">
                        <h2>Manual Options ({options.length})</h2>
                        <p>Add the choices for dropdown (`react-select`) or radio button questions. This section is disabled if a 'Dynamic Options Source' is chosen.</p>
                    </div>
                </div>
                {disabled && <p className="text-xs text-orange-700 mb-2">Manual options are disabled because a dynamic source is selected above.</p>}

                {options.map((option, index) => {
                    const display = getOptionDisplay(option);
                    return (
                        <div key={index} className="row">
                            <div className="col-xl-6 labelBlock">
                                <div className="custom_input_flled">
                                    <label>Label (Display Text)</label>
                                    <input style={{maxWidth: 'unset'}} type="text" value={display.label} onChange={(e) => handleOptionChange(index, 'label', e.target.value)} disabled={disabled} className="form-control sm_input filled_white" />
                                    <div className="stats_filled mt-1">
                                        <p>The text the user will see.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 labelBlock">
                                <div className="custom_input_flled">
                                    <label>Value (Stored Value)</label>
                                    <input style={{maxWidth: 'unset'}} type="text" value={display.value} onChange={(e) => handleOptionChange(index, 'value', e.target.value)} disabled={disabled} className="form-control sm_input filled_white" />
                                    <div className="stats_filled mt-1">
                                        <p>The data that gets saved.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="text-right">
                                <Button variant='danger' onClick={() => removeOption(index)} disabled={disabled} className={`btn_sm ${disabled ? '' : ''}`}>
                                    Remove
                                </Button>
                            </div>
                        </div>
                    );
                })}
                <div className="mt-4">
                    <Button variant='primary' onClick={addOption} disabled={disabled} className={`btn_sm ${disabled ? '' : ''}`}>
                        Add Manual Option
                    </Button>
                </div>
            </div>
        </>
    );
};

export default OptionsEditor;